var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.09 0.59C14.71 0.21 14.2 0 13.67 0H2.5C1.39 0 0.5 0.9 0.5 2V16C0.5 17.1 1.4 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V4.83C18.5 4.3 18.29 3.79 17.91 3.42L15.09 0.59ZM9.5 16C7.84 16 6.5 14.66 6.5 13C6.5 11.34 7.84 10 9.5 10C11.16 10 12.5 11.34 12.5 13C12.5 14.66 11.16 16 9.5 16ZM10.5 6H4.5C3.4 6 2.5 5.1 2.5 4C2.5 2.9 3.4 2 4.5 2H10.5C11.6 2 12.5 2.9 12.5 4C12.5 5.1 11.6 6 10.5 6Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.99a12eb84270bac366a0b7d8e8436704.svg";
export { ForwardRef as ReactComponent };